export const HALO_STATUS = {
  IDLE: 'idle',
  WORKING: 'working',
  DONE: 'done',
  SETTLED: 'settled',
} as const;

export type HaloStatus = (typeof HALO_STATUS)[keyof typeof HALO_STATUS];
